import Info from "assets/Advertencia.svg";
import React from "react";
import {
  actions as detailTransactionActions,
  detailTransactionSelector,
} from "reducers/detailTransaction";
import { connect } from "react-redux";
import {
  actions as transactionActions,
  transactionsSelector,
} from "reducers/transactions";
import "./reasonsCanceledConfirm.scss";
import { AppDispatch, RootState } from "store";
import { ReasonCanceledConfirmPropsType } from "./types";
import { postCancelType } from "sagas/types/detailTransactions";
import { FilterTransactionsType } from "sagas/types/transactions";
import "../i18n";
import { useTranslation } from "react-i18next";
import { BackButton } from "../backButton/BackButton";
import { TRANSACTION_CANCELLATION_REASON, TRANSACTION_STATE_TAG } from "utils/constants";

const ReasonsCanceledConfirm: React.FC<ReasonCanceledConfirmPropsType> = ({
  detailTransaction,
  messageSelected,
  back,
  postReasonsCanceled,
  getTransactions,
  filters,
  filtersExtra,
}): JSX.Element => {
  const { t } = useTranslation();

  const isInPickUpState = 
    detailTransaction.transaction.state.tag === TRANSACTION_STATE_TAG.IN_PICK_UP || 
    detailTransaction.transaction.state.tag === TRANSACTION_STATE_TAG.IN_PICK_UP_POINT;

  const isCancellationReasonValid = 
    messageSelected?.id === TRANSACTION_CANCELLATION_REASON.PERSONAL_OR_TRANSPORTATION_REASONS || 
    messageSelected?.id === TRANSACTION_CANCELLATION_REASON.COLLECTION_POINT_NOT_FOUND;

  return (
    <div className="container-finish">
      <BackButton back={back} />
      {(isInPickUpState && isCancellationReasonValid) ? (
        <div className="flex-container">
          <img
            className="modal-transaction-reasonsCanceledConfirm-img"
            src={Info}
            alt="informacionIcon"
          />
          <h3>{t("detailTransaction:cancelCollection")}</h3>
          <hr className="modal-transaction-finish-separate" />
          <p className="modal-transaction-reasonsCanceledConfirm">
            {t("detailTransaction:cancelWarning")}
          </p>
          <p className="modal-transaction-reasonsCanceledConfirm">
            {t("detailTransaction:cancelConfirmation")}
          </p>
        </div>
      ) : (
        <div className="flex-container">
          <img
            className="modal-transaction-reasonsCanceledConfirm-img"
            src={Info}
            alt="informacionIcon"
          />
          <h3>{t("detailTransaction:cancelTransaction")}</h3>
          <hr className="modal-transaction-finish-separate" />
          <div className="flex-container">
            <p className="modal-transaction-reasonsCanceledConfirm">
              {t("detailTransaction:confirmCancelTransaction")}
            </p>
            <p className="modal-transaction-reasonsCanceledConfirm">
              {t("detailTransaction:confirmCancelTransactionQuestion")}
            </p>
          </div>
        </div>
      )}
      <button
        onClick={() => {
          postReasonsCanceled(
            messageSelected?.id,
            detailTransaction.transaction.id,
            () => {
              getTransactions({
                ...filters,
                offset: 0,
              });
            }
          );
        }}
        className="modal-transaction-reasonsCanceledConfirm-button"
      >
        {t("detailTransaction:confirmCancelTransactionQConfimr")}
      </button>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  detailTransaction: detailTransactionSelector(state).detailTransaction,
  messageSelected: detailTransactionSelector(state).messageSelected,
  filters: transactionsSelector(state).filters,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getTransactions: (params: FilterTransactionsType) => {
    dispatch(transactionActions.getTransactionsRequest(params));
  },
  postReasonsCanceled: (
    params: postCancelType,
    id: string,
    callBack: Function
  ) => {
    dispatch(
      detailTransactionActions.getDetailTransactionReasonsCanceledRequest({
        id,
        params,
        callBack,
      })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReasonsCanceledConfirm);
